import styled from 'styled-components';
import type { ColumnsType } from 'antd/es/table';
import { Colors, Table, Text, Row, Box } from 'basic-ui-lib';
import { IcTick } from 'basic-ui-lib/icons';
import { ILink } from 'modules/media/interfaces/api';

interface LinkTabContentProps {
  links: ILink[];
  selectedLinkId?: string[] | null;
  onLinkRowClick: (record: ILink) => void;
}

const LinkTabContent = ({ links, selectedLinkId, onLinkRowClick }: LinkTabContentProps) => {
  const linkColumns: ColumnsType<ILink> = [
    {
      title: 'MEDIA',
      dataIndex: 'name',
      render: (text, record) => {
        const isSelected = selectedLinkId?.includes(String(record.urlLink));
        return (
          <Row gap={12} alignItems='center'>
            <Box
              width={24}
              height={24}
              borderRadius="50%"
              border={`2px solid ${isSelected ? Colors.secondary[4] : Colors.neutral.border[2]}`}
              background={isSelected ? Colors.secondary[4] : 'transparent'}
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              {isSelected && (
                <IcTick width={14} height={14} fill="#FFFFFF" />
              )}
            </Box>
            <Text body_1 medium color='neutral.text.5'>
              {text}
            </Text>
          </Row>
        );
      },
    },
    {
      title: 'Link',
      dataIndex: 'urlLink',
      render: (url) => (
        <LinkText href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
          {url}
        </LinkText>
      ),
    },
    {
      title: 'UPLOADED DATE',
      dataIndex: 'createdDate',
    },
  ];

  return (
    <TableWrapper>
      <Table<ILink>
        columns={linkColumns}
        dataSource={links}
        pagination={false}
        rowKey={(record) => String(record.id)}
        onRow={(record) => ({
          onClick: () => onLinkRowClick(record),
          style: { 
            cursor: 'pointer',
            background: selectedLinkId?.includes(String(record.id)) ? Colors.primary[1] : 'transparent',
          },
        })}
      />
    </TableWrapper>
  );
};

export default LinkTabContent;

const TableWrapper = styled.div`
  .ant-table-thead > tr > th {
    background: ${Colors.neutral.bg[3]};
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: ${Colors.neutral.text[3]};
  }
  
  .ant-table-tbody > tr:hover > td {
    background: ${Colors.neutral.bg[2]};
  }
`;

const LinkText = styled.a`
  color: ${Colors.primary[5]};
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 250px;

  &:hover {
    text-decoration: underline;
  }
`;
